export default {
  index: {
    search: {
      title: 'Price Guide',
      subtitle: 'Discover and compare gear value',
      placeholder: 'Search by brand and model',
      marketplaceLinkText: 'Search Marketplace',
    },
    instructions: {
      title: 'How it works',
      step1: '1) Search for gear',
      step2: '2) Enter gear details for accurate range',
      step3: '3) Review how much it\'s worth',
    },
    card: {
      button: 'Get Price Estimate',
      multipleFinishes: 'Multiple Finishes',
    },
  },
  show: {
    form: {
      gearDetails: 'Gear Details',
      modelVersion: 'Model Version',
      condition: 'Condition',
      category: 'Category',
      disclaimer: 'We only use this information temporarily to give you an accurate representation of gear value and it is not stored.',
      conditionHelpText: 'Learn more about our conditions',
      backButtonText: 'Back',
      priceGearButtonText: 'Price Gear',
      results: {
        reverbEstimatedValue: 'Reverb Estimated Value',
        condition: 'Condition',
        estimateUnavailable: 'Estimate from Reverb not available.',
        pastThirtyDays: 'Past 30 Days',
        averageItemPriceSold: 'Average Item Price Sold',
        sellYoursButtonText: 'Sell Yours',
        viewLiveListingsText: 'View Live Listings',
      },
    },
  },
};
